export default "__VITE_ASSET__Chj5Wyy6__"